module.exports = __webpack_public_path__ + "assets/img/robot_test_l4.5c9aecd9.jpg";